import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, Lock } from "lucide-react";
import BottomMenu from "../../../../components/common/Authenticated/Menu/Menu";
import api from "../../../../services/api";
import SHA256 from "crypto-js/sha256";

const AlterarSenha = () => {
  const navigate = useNavigate();
  const usuarioStorage = JSON.parse(localStorage.getItem("usuario")) || {};
  const token = localStorage.getItem("token");

  const [senhaData, setSenhaData] = useState({
    novaSenha: "",
    confirmacaoNovaSenha: "",
  });
  const [loading, setLoading] = useState(false);

  const Voltar = () => {
    navigate("/area-restrita/minha-conta");
  };

  const handleCampoChange = (campo, valor) => {
    setSenhaData((prev) => ({ ...prev, [campo]: valor }));
  };

  const enviarAtualizacao = async () => {
    if (!senhaData.novaSenha || !senhaData.confirmacaoNovaSenha) {
      alert("Preencha todos os campos.");
      return;
    }

    if (senhaData.novaSenha !== senhaData.confirmacaoNovaSenha) {
      alert("As senhas precisam ser iguais.");
      return;
    }

    try {
      setLoading(true);

      // Criptografa a senha antes de enviar
      const senhaCriptografada = SHA256(senhaData.novaSenha).toString();

      const { data } = await api.put(
        `cliente/senha/${usuarioStorage._id}`,
        {
          novaSenha: senhaCriptografada,
          confirmacaoNovaSenha: senhaCriptografada,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (!data.error) {
        alert(data.message || "Senha alterada com sucesso!");
        navigate("/area-restrita/minha-conta");
      } else {
        alert(data.message || "Erro ao alterar senha.");
      }
    } catch (err) {
      console.error("Erro ao alterar senha:", err.message);
      alert("Erro ao alterar senha. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Botão de voltar */}
      <button
        onClick={Voltar}
        className="absolute top-3 left-2 bg-[#003D42] p-2 rounded-full z-10 flex items-center justify-center shadow-md w-9 hover:bg-[#002d30] transition"
      >
        <ChevronLeft size={20} color="#fff" />
      </button>

      <div className="min-h-screen flex flex-col justify-center items-center p-4 bg-gray-50 mt-[-50px]">
        <div className="flex flex-col items-center text-center">
          <Lock size={50} className="text-[#003D42]" />
          <h1 className="text-2xl font-semibold text-gray-800 mt-4">
            Alterar senha
          </h1>
          <p className="text-gray-500 text-sm mt-1">
            Atualize sua senha para manter sua conta segura
          </p>
        </div>

        <div className="w-[80vw] max-w-lg mt-6 flex flex-col bg-white p-6 rounded-lg shadow-md">
          <label className="mt-2 font-[20px] sm:font-medium text-gray-700">Nova senha</label>
          <input
          type="password"
          placeholder="Digite a sua senha"
          value={senhaData.novaSenha}
          onChange={(e) => handleCampoChange("novaSenha", e.target.value)}
          className="border border-gray-300 rounded-md text-[16px] p-3 mt-1 focus:border-[#003D42] focus:ring-1 focus:ring-[#003D42]"
        />


          <label className="mt-4 font-medium text-gray-700">
            Confirme a nova senha
          </label>
          <input
            type="password"
            placeholder="Confirme a sua senha"
            value={senhaData.confirmacaoNovaSenha}
            onChange={(e) =>
              handleCampoChange("confirmacaoNovaSenha", e.target.value)
            }
            className="border border-gray-300 rounded-md text-[16px] p-2 mt-1 focus:border-[#003D42] focus:ring-1 focus:ring-[#003D42]"
          />

          <button
            onClick={enviarAtualizacao}
            disabled={loading}
            className={`mt-6 w-full bg-[#003D42] text-white font-semibold py-3 rounded-md shadow-md hover:bg-[#002d30] transition ${
              loading ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            {loading ? "Alterando..." : "Alterar senha"}
          </button>
        </div>
      </div>

      <BottomMenu />
    </>
  );
};

export default AlterarSenha;
